import { Link } from "react-router-dom"
import '../styles/components/button.css'

const Button = (
    {
        href,
        onClick,
        children,
        className = ''
    }    
) => {
    const classes = ['btn-primary',  className].join(' ')
    
    return (
        <>
            {
                href ? 
                    <Link to={href} onClick={onClick} className={classes}>
                        {children}
                    </Link>
                :
                    <button onClick={onClick} className={classes}>
                        {children}
                    </button>
            }
        </>
    )
}

export default Button